module.exports = __webpack_public_path__ + "ah.no2.504a76df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ah.no2.jpg
// module id = 6U1R
// module chunks = 0